import PropPagination from './index';

export default angular.module('edge.platform.widgets.propertiespagination', []).component('gwPropertiesPagination', PropPagination);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/propertiespagination/module.js
// module id = 1146
// module chunks = 0